"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AppSwitcher =
/*#__PURE__*/
function (_Component) {
  _inherits(AppSwitcher, _Component);

  function AppSwitcher(props) {
    _classCallCheck(this, AppSwitcher);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppSwitcher).call(this, props));
  }

  _createClass(AppSwitcher, [{
    key: "openApp",
    value: function openApp(url) {
      location.href = url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement("div", {
        className: "app-switcher"
      }, _react.default.createElement("div", {
        className: "apps-container"
      }, _react.default.createElement("div", {
        className: "apps-wrapper"
      }, _react.default.createElement("div", null, this.props.data.apps.map(function (app, index) {
        return _react.default.createElement("div", {
          key: index,
          className: app.isActive ? "app-switcher-item app-switcher-item-active" : "app-switcher-item",
          onClick: function onClick() {
            return _this.openApp(app.url);
          }
        }, _react.default.createElement("div", {
          className: "app-switcher-item-icon-container"
        }, _react.default.createElement("div", {
          className: "image-cropper"
        }, _react.default.createElement("img", {
          alt: "",
          src: app.img,
          className: "app-switcher-item-icon"
        }))), _react.default.createElement("div", {
          className: "app-switcher-item-text-container"
        }, _react.default.createElement("span", {
          className: "regular-link-text app-switcher-item-text"
        }, app.title), _react.default.createElement("br", null), _react.default.createElement("span", {
          className: "small-body-text"
        }, app.description)));
      })))));
    }
  }]);

  return AppSwitcher;
}(_react.Component);

var _default = AppSwitcher;
exports.default = _default;